<!-- Toggle button + inline #1 peek (always visible) -->
<div class="lb-toggle-area" [class.collapsed]="isCollapsed">
  <button class="lb-toggle-btn" (click)="toggleCollapse()">
    <svg class="toggle-trophy" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M7 4h10v5a5 5 0 01-10 0V4z" fill="#FFD700"/><path d="M5 4h2v4a3 3 0 01-3 3h0a1 1 0 01-1-1V7a3 3 0 013-3z" fill="#FFC107"/><path d="M19 4h-2v4a3 3 0 003 3h0a1 1 0 001-1V7a3 3 0 00-3-3z" fill="#FFC107"/><rect x="10" y="13" width="4" height="3" rx="1" fill="#FFA000"/><rect x="8" y="16" width="8" height="2" rx="1" fill="#FFD700"/></svg>
    <span class="toggle-text">{{ currLang === 'ar' ? 'الترتيب' : 'Ranks' }}</span>
    <span class="toggle-arrow" [class.open]="!isCollapsed">&#9654;</span>
  </button>

  <!-- Inline #1 student peek (only when collapsed) -->
  <div class="lb-peek-inline" *ngIf="isCollapsed && topStudents.length > 0" @peekSlide (click)="toggleCollapse()">
    <span class="peek-medal" *ngIf="topStudents[0].xp > 0">{{ getRankIcon(topStudents[0].rank) }}</span>
    <span class="rank-num peek-rank" *ngIf="topStudents[0].xp === 0">#{{ topStudents[0].rank | arabicNumber:currLang }}</span>
    <app-student-avatar
      [student]="topStudents[0].student"
      [size]="24"
      [highlight]="true">
    </app-student-avatar>
    <span class="peek-name">{{ getShortName(topStudents[0]) }}</span>
    <span class="peek-xp">{{ topStudents[0].xp | arabicNumber:currLang }}</span>
  </div>
</div>

<!-- Leaderboard Panel -->
<div class="live-leaderboard" [class.hidden]="isCollapsed">
  <!-- Header -->
  <div class="lb-header">
    <span class="lb-title">
      <svg class="trophy" width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M7 4h10v5a5 5 0 01-10 0V4z" fill="#FFD700"/><path d="M5 4h2v4a3 3 0 01-3 3h0a1 1 0 01-1-1V7a3 3 0 013-3z" fill="#FFC107"/><path d="M19 4h-2v4a3 3 0 003 3h0a1 1 0 001-1V7a3 3 0 00-3-3z" fill="#FFC107"/><rect x="10" y="13" width="4" height="3" rx="1" fill="#FFA000"/><rect x="8" y="16" width="8" height="2" rx="1" fill="#FFD700"/></svg>
      {{ currLang === 'ar' ? 'الترتيب' : 'Leaderboard' }}
    </span>
    <button class="lb-close" (click)="toggleCollapse()">
      <span>&#10005;</span>
    </button>
  </div>

  <!-- Student List -->
  <div class="lb-list">
    <div *ngFor="let entry of scores; let i = index; trackBy: trackByStudent"
         class="lb-row"
         [class.active-student]="entry.student.id === currentStudentId"
         [class.rank-up]="entry.rankChange === 'up'"
         [class.rank-down]="entry.rankChange === 'down'"
         [style.animation-delay]="i * 0.05 + 's'"
         @listEntry>

      <!-- Rank Number -->
      <div class="lb-rank">
        <span class="rank-medal" *ngIf="entry.rank <= 3 && entry.xp > 0">{{ getRankIcon(entry.rank) }}</span>
        <span class="rank-num" *ngIf="entry.rank > 3 || entry.xp === 0">#{{ entry.rank | arabicNumber:currLang }}</span>
        <span class="rank-change-icon" *ngIf="entry.rankChange === 'up'" [class.up]="true">
          {{ getRankChangeIcon('up') }}
        </span>
        <span class="rank-change-icon" *ngIf="entry.rankChange === 'down'" [class.down]="true">
          {{ getRankChangeIcon('down') }}
        </span>
      </div>

      <!-- Student Info -->
      <div class="lb-student">
        <app-student-avatar
          [student]="entry.student"
          [size]="32"
          [active]="entry.student.id === currentStudentId"
          [highlight]="entry.rank === 1">
        </app-student-avatar>
        <span class="student-name">{{ getShortName(entry) }}</span>
        <span class="streak-badge" *ngIf="entry.streak >= 3">
          {{ getStreakEmoji(entry.streak) }}{{ entry.streak | arabicNumber:currLang }}
        </span>
      </div>

      <!-- XP -->
      <div class="lb-xp">
        <span class="xp-value">{{ entry.xp | arabicNumber:currLang }}</span>
        <span class="xp-label">XP</span>
        <!-- Floating XP gain -->
        <span class="xp-float" *ngIf="showXpFloat[entry.student.id]" @xpPop>
          +{{ showXpFloat[entry.student.id] | arabicNumber:currLang }}
        </span>
      </div>

      <!-- Accuracy bar -->
      <div class="lb-accuracy" *ngIf="entry.totalAnswered > 0">
        <div class="accuracy-fill"
             [style.width.%]="(entry.correctCount / entry.totalAnswered) * 100">
        </div>
      </div>
    </div>
  </div>
</div>
